import React, { PureComponent, Fragment } from 'react'
import { Card, CardText, CardBody, CardTitle } from 'reactstrap'
import ReactTooltip from 'react-tooltip'
import { toMoney } from 'helpers'

class SatBody  extends PureComponent {

    render() {

        return (
            <Fragment>
                
                {this.props.lista.map((p, index) => {
                        return (
                            <div key={index} className="col col-sm-4 company-card">

                                <Card className="shadow-effect">
                                    <CardBody>
                                        <CardTitle className="company-title">{p.nomeEmpresa}</CardTitle>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Mapa Resumo:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {toMoney(p['totalMapaResumo'].toFixed(2))}
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Venda det. (Data caixa):</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['vendaDetalhadaCaixa'] !== 0 ? <span data-emp={p._id} data-detail="venda_detalhada_caixa" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['vendaDetalhadaCaixa'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText data-tip="Mapa Resumo - Venda detalhada (caixa)" data-effect="solid" className="company-values">Diferença:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {toMoney(p['difMapa'].toFixed(2))}
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Venda det. (Data venda):</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['vendaDetalhada'] !== 0 ? <span data-emp={p._id} data-detail="venda_detalhada" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['vendaDetalhada'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Cupons emitidos (AS):</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['cuponsEmitidos'] !== 0 ? <span data-emp={p._id} data-detail="cupons_emitidos" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['cuponsEmitidos'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Cupons emitidos (SEFAZ):</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['totalSefaz'] !== 0 ? <span data-emp={p._id} data-detail="cupons_emitidos_sefaz" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['totalSefaz'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Cupons cancelados:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['totalCancelados'] !== 0 ? <span data-emp={p._id} data-detail="cupons_cancelados" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['totalCancelados'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Notas 55:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['notas55'] !== 0 ? <span data-emp={p._id} data-detail="notas55" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['notas55'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText id="receita-fiscal" data-tip="Cupons emitidos (AS) + notas 55" data-effect="solid" className="company-values">Receita fiscal: </CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">{toMoney((p['notas55'] + p['cuponsEmitidos']).toFixed(2))}</CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Venda det. - Receita:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">{toMoney(Math.abs((p['notas55'] + p['cuponsEmitidos']) - p['vendaDetalhada']).toFixed(2))}</CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Vendas s/número:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['semNumero'] !== 0 ? <span data-emp={p._id} data-detail="vendas_sem_numero" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['semNumero'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Notas rejeitadas:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['notasRejeitadas'] !== 0 ? <span data-emp={p._id} data-detail="notas_rejeitadas" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['notasRejeitadas'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Somente SEFAZ:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['totalSomenteSefaz'] !== 0 ? <span data-emp={p._id} data-detail="somente_sefaz" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['totalSomenteSefaz'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Cancelados na Venda Det.:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['totalCanceladosVendaDet'] !== 0 ? <span data-emp={p._id} data-detail="cancelados_vendas" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['totalCanceladosVendaDet'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        
                                    </CardBody>
                                </Card>
                                <ReactTooltip />
                            </div>
                        )
                    })}

            </Fragment>
        )

    }
}

export default SatBody